import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  checkQuarterValidation,
  handleScrollToEvent,
  quarterFormatter,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  changeFieldValidationClaimGroup,
  deleteRpcClaimGroupParam,
  dispatchErrorMessages,
  dispatchSuccessMessages,
  getClaimGrouping,
  getMaxQuarterForFreezeDt,
  getRebateProgramCode,
  getRpcClaimGroupingParam,
  setCGPSearchValues,
  updateRpcClaimGroupingParam,
} from '../store/actions';
import { getUserDefaults } from '../../UserDefault/store/actions';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  autoFormateDate,
  isReadOnly as isRead,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  quarterLabelName,
  radioGroupLabelNamePlan,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { getPlanTypeRadioBoxValue } from '../../../Research/UnderThresholdInvoices/store/Actions';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { GROUPING_COLUMN_REQUIRED, QUARTER_REQUIRED } from './constantData';

export const groupingColumnList = [
  { label: 'Alternate Provider ID', value: 'Alternate Provider ID' },
  { label: 'Plan ID', value: 'Plan ID' },
  { label: 'MCO Indicator', value: 'MCO Indicator' },
];

const ClaimGroupingParameter = ({ location }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState)?.readOnly || false;
  }

  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.CGPReducer?.errorMessages
  );
  const successMessages = useSelector(
    (state) => state.sharedState.CGPReducer?.successMessages
  );
  const CGPSearchValues = useSelector(
    (state) => state.sharedState.CGPReducer?.CGPSearchValues
  );
  const rebateProgramCode = useSelector(
    (state) => state.sharedState.CGPReducer?.rebateProgramCode?.data
  );
  const UserDefaultsValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues?.data
  );
  const defaultQtrRIC = useSelector(
    (state) => state.sharedState.CGPReducer?.defaultQtrRIC?.data
  );
  const stortedGroupingColumns = useSelector(
    (state) => state.sharedState.CGPReducer?.stortedGroupingColumns
  );

  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));
  const setSuccessMessages = (values) =>
    dispatch(dispatchSuccessMessages(values));
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [fullScreenView, setFullScreenView] = useState(false);
  const [
    isOpenChangeGroupingColumnConfirmModal,
    setIsOpenChangeGroupingColumnConfirmModal,
  ] = useState(false);
  const [disableGroupingColumn, setDisableGroupingColumn] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [changeGroupingColumnMsg, setChangeGroupingColumnMsg] = useState('');
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);
  useEffect(() => {
    const ele = document.querySelector('.nav-item-active a .tab-title');
    if (ele) {
      ele.textContent = 'Request Claim Grouping Parameters';
    }
    getUserDefaultValues(logInUser);
    dispatch(getMaxQuarterForFreezeDt());
    dispatch(
      setCGPSearchValues({
        ...CGPSearchValues,
        planType: !CGPSearchValues?.planType
          ? UserDefaultsValues?.planTypeCd || 'FD'
          : CGPSearchValues?.planType,
        rebateProgramCd:
          !CGPSearchValues?.rebateProgramCd ||
          CGPSearchValues?.rebateProgramCd === '-1'
            ? UserDefaultsValues?.rebateProgramCd
            : CGPSearchValues?.rebateProgramCd,
      })
    );
    handleScrollToEvent();
    getPlanTypeRadioBoxValue().then((res) => {
      const planList =
        res?.length > 0 &&
        res?.map((obj) => {
          return {
            name:
              obj?.codeValueID?.codeValue === 'FD'
                ? 'Medicaid'
                : obj.shortDescription,
            value: obj.codeValueID.codeValue,
          };
        });
      setPlanTypeOptions(planList);
    });
  }, []);

  useEffect(() => {
    if (defaultQtrRIC) {
      dispatch(
        setCGPSearchValues({
          ...CGPSearchValues,
          quarter: !CGPSearchValues?.quarter
            ? defaultQtrRIC
            : CGPSearchValues?.quarter,
          planType: !CGPSearchValues?.planType
            ? UserDefaultsValues?.planTypeCd
            : CGPSearchValues?.planType,
          rebateProgramCd:
            !CGPSearchValues?.rebateProgramCd ||
            CGPSearchValues?.rebateProgramCd === '-1'
              ? UserDefaultsValues?.rebateProgramCd
              : CGPSearchValues?.rebateProgramCd,
        })
      );
    }
  }, [defaultQtrRIC]);
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux && errorMessagesFromRedux.length > 0) {
      tabHighLigther('/claimGroupingParameter', true);
    } else {
      tabHighLigther('/claimGroupingParameter', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // highlight tab if it has error

  useEffect(() => {
    if (CGPSearchValues?.planType) {
      dispatch(getRebateProgramCode(CGPSearchValues.planType));
    }
    if (isMounted && CGPSearchValues.planType) {
      dispatch(
        setCGPSearchValues({
          ...CGPSearchValues,
        })
      );
    }
    setIsMounted(true);
  }, [CGPSearchValues.planType]);

  useEffect(() => {
    if (
      CGPSearchValues?.rebateProgramCd &&
      CGPSearchValues?.rebateProgramCd !== '-1' &&
      CGPSearchValues?.quarter &&
      quarterFormatter(CGPSearchValues.quarter)
    ) {
      dispatch(
        getRpcClaimGroupingParam({
          rebateProgramCd: CGPSearchValues?.rebateProgramCd,
          startQtr: CGPSearchValues?.quarter,
          endQtr: CGPSearchValues?.quarter,
        })
      );
    }
  }, [CGPSearchValues?.rebateProgramCd, CGPSearchValues?.quarter]);
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux || [];
    if (value !== 'Selected') {
      localErr = localErr.filter((item) => item.field !== 'resultNotFound');
      dispatch(
        setCGPSearchValues({
          ...CGPSearchValues,
          [name]: value,
        })
      );
      dispatch(dispatchErrorMessages([...new Set(localErr)]));
    } else if (name === 'planTypeCd') {
      dispatch(
        setCGPSearchValues({
          ...CGPSearchValues,
          [name]: value,
          rebateProgramCd: '-1',
        })
      );
    } else {
      dispatch(
        setCGPSearchValues({
          ...CGPSearchValues,
          [name]: value,
        })
      );
    }
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux || [];
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'groupingColumn') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'groupingColumn' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'groupingColumn',
          errorType: 'groupingColumnRequired',
          message: GROUPING_COLUMN_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'groupingColumn' && item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          dispatch(
            setCGPSearchValues({
              ...CGPSearchValues,
              quarter: autoFormateDate(value?.toUpperCase()),
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_REQUIRED,
        });
      }
    }
    dispatch(dispatchErrorMessages([...new Set(localErr)]));
  };

  const process = async () => {
    if (validateCGPSearchForm()) {
      await dispatch(
        getClaimGrouping({
          rebateProgramCd: CGPSearchValues.rebateProgramCd,
          groupingColumn: CGPSearchValues.groupingColumn,
          groupingColumnValue: stortedGroupingColumns.find(
            (obj) => obj.groupingColumn === CGPSearchValues.groupingColumn
          )?.groupingColumnValue,
          qtr: CGPSearchValues.quarter,
          showAllCheckBox: false,
        })
      );
      redirectURLLink(
        '/claimGroupingParameterDetail',
        'Maintain RPC Claim Grouping Parameters',
        history,
        dispatch,
        isReadOnly
      );
    }
  };

  const validateCGPSearchForm = () => {
    let localErr = errorMessagesFromRedux || [];
    if (
      !CGPSearchValues?.rebateProgramCd ||
      CGPSearchValues?.rebateProgramCd === '-1'
    ) {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
      );
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    } else {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
      );
    }
    if (
      !CGPSearchValues?.groupingColumn ||
      CGPSearchValues?.groupingColumn === '-1'
    ) {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'groupingColumn' && item.field !== 'resultNotFound'
      );
      localErr.push({
        field: 'groupingColumn',
        errorType: 'groupingColumnRequired',
        message: GROUPING_COLUMN_REQUIRED,
      });
    } else {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'groupingColumn' && item.field !== 'resultNotFound'
      );
    }
    if (
      CGPSearchValues?.quarter &&
      !_.isEmpty(CGPSearchValues?.quarter) &&
      !_.isNaN(CGPSearchValues?.quarter)
    ) {
      localErr = localErr?.filter(
        (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
      );
      if (checkQuarterValidation(CGPSearchValues?.quarter)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'invalidFormat',
          message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
        });
      }
    } else {
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_REQUIRED,
      });
    }
    return !(localErr.length > 0);
  };

const showChangeGroupingColumnConfirmModal = async () => {
  const response = await dispatch(
    changeFieldValidationClaimGroup({
      rebateProgramCd: CGPSearchValues.rebateProgramCd,
      qtr: CGPSearchValues.quarter,
    })
  );

  let message = "";

  if (typeof response === "string") {
    message = response;
  } else if (response?.message) {
    message = response.message;
  } else if (response?.data?.message) {
    message = response.data.message;
  } else {
    message = JSON.stringify(response);
  }

  setChangeGroupingColumnMsg(message);
  setIsOpenChangeGroupingColumnConfirmModal(true);
};

  useEffect(() => {
    checkDisabledGroupingColumn();
  }, [stortedGroupingColumns]);

  const checkDisabledGroupingColumn = () => {
    if (stortedGroupingColumns?.length > 0) {
      setDisableGroupingColumn(true);
    } else {
      setDisableGroupingColumn(false);
    }
  };

  return (
    <div className="tBillPanel custom-check">
      <SaveCancelPopup
        open={isOpenChangeGroupingColumnConfirmModal}
        title="Change"
        content={changeGroupingColumnMsg}
        moduleName="Grouping Column"
        onConfim={async () => {
          setIsOpenChangeGroupingColumnConfirmModal(false);
          if (
            String(changeGroupingColumnMsg).includes(
              'All existing grouping rows will be deleted.'
            )
          ) {
            const successMsg = await dispatch(
              deleteRpcClaimGroupParam({
                rebateProgramCd: CGPSearchValues.rebateProgramCd,
              })
            );
            setSuccessMessages([successMsg]);
            setDisableGroupingColumn(false);
          } else if (
            String(changeGroupingColumnMsg).includes(
              'Selection of a new column will end all existing rows as of'
            )
          ) {
            const successMsg = await dispatch(
              updateRpcClaimGroupingParam({
                rebateProgramCd: CGPSearchValues.rebateProgramCd,
                startQtr: CGPSearchValues.quarter,
                maxQtr: defaultQtrRIC,
              })
            );
            setSuccessMessages([successMsg]);
            setDisableGroupingColumn(false);
          } else if (
            String(changeGroupingColumnMsg).includes(
              'Any groupings entered will have an end qtr'
            )
          ) {
            setDisableGroupingColumn(false);
          } else {
            setDisableGroupingColumn(false);
          }
        }}
        onCancel={() => setIsOpenChangeGroupingColumnConfirmModal(false)}
        onClose={() => setIsOpenChangeGroupingColumnConfirmModal(false)}
      />
      <div className="panel tBillPanel-space devider-line pb-0">
        <Spinner load={spinnerLoader} />
        <CustomSeparator
          parent1="System"
          parent2="Request Claim Grouping Parameters"
        />
        {!fullScreenView && (
          <>
            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  errorMessagesFromRedux?.length > 0
                    ? _.map(errorMessagesFromRedux, (l) => l.message)
                    : []
                ),
              ]}
            />
            <DisplaySuccessMessages successMessages={successMessages} />
            <div className="panel mb-3">
              <div className="row">
                {/* Plan Type */}
                <div className="col-4 frr-two-col-radio">
                  <RadioGroupComponent
                    data-testid="filter-plan-by-radio-btn-plan"
                    id="filter-plan-by-radio-btn-action"
                    labelName={radioGroupLabelNamePlan}
                    required
                    optionList={planTypeOptions}
                    defaultValue={CGPSearchValues?.planType}
                    filterAction={(e) => {
                      handleOnChangeEvent(e, 'planType');
                    }}
                    className="log-batch-filter-radio frr-checkInvoiceRadio"
                  />
                </div>

                {/* Rebate Program */}
                <div className="col-4 frr-two-col-radio ">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      Rebate Program<span className="mandatory"> *</span>
                    </legend>
                    <div className="form-wrapper p-3">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <TextField
                          name="rebateProgram"
                          id="rebate_program_CGPS"
                          label="Rebate Program_CGPS"
                          data-testid="req-prgm-rbt"
                          fullWidth
                          select
                          required
                          inputProps={{
                            maxLength: 11,
                            id: 'rebate_program_CGPS',
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          className={
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? 'mandate-fields'
                                    : null
                                )
                              : null
                          }
                          onBlur={(e) =>
                            handleOnblurEvent('rebateProgramCd', e.target.value)
                          }
                          onChange={(e) =>
                            handleOnChangeEvent(
                              e?.target?.value,
                              'rebateProgramCd'
                            )
                          }
                          value={CGPSearchValues?.rebateProgramCd || '-1'}
                          error={
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? l.message
                                    : null
                                )
                              : null
                          }
                          helperText={
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? l.message
                                    : null
                                )
                              : null
                          }
                        >
                          <MenuItem
                            key=""
                            value="-1"
                            className="frr-dropdown-blank-item"
                          />
                          {rebateProgramCode?.length > 0
                            ? rebateProgramCode.map((item) => {
                                return (
                                  <MenuItem
                                    key={item.rebateProgramCd}
                                    value={item.rebateProgramCd}
                                    className="frr-logcheck-dropdown-item"
                                  >
                                    {`${item.rebateProgramCd} | ${item.shortDescr}`}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                    </div>
                  </fieldset>
                </div>
                {/* Quarter */}
                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      As Of Quarter <span className="mandatory"> {'  *'}</span>
                    </legend>
                    <div className="form-wrapper p-0 h-100">
                      <div className="mui-custom-form with-select field-xl no-lbl d-flex align-items-center">
                        <label
                          className="m-0 visually-hidden"
                          htmlFor="quarter"
                        >
                          <span>label</span>{' '}
                        </label>
                        <TextField
                          data-testid="check_quarter_ia"
                          id="check_by_invoice_quater"
                          required
                          label={quarterLabelName}
                          fullWidth
                          placeholder=""
                          inputProps={{ maxLength: 6 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={CGPSearchValues?.quarter || ''}
                          onChange={(e) => {
                            handleOnChangeEvent(e.target.value, 'quarter');
                          }}
                          onBlur={(e) =>
                            handleOnblurEvent('quarter', e.target.value)
                          }
                          className={
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.field === 'quarter'
                                    ? 'mandate-fields'
                                    : null
                                )
                              : null
                          }
                          helperText={[
                            ...new Set(
                              errorMessagesFromRedux?.length > 0
                                ? _.map(errorMessagesFromRedux, (l) =>
                                    l.field === 'quarter' ? l.message : null
                                  )
                                : null
                            ),
                          ]}
                          error={[
                            ...new Set(
                              errorMessagesFromRedux?.length > 0
                                ? _.map(errorMessagesFromRedux, (l) =>
                                    l.field === 'quarter' ? l.message : null
                                  )
                                : null
                            ),
                          ]}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-4">
                  <div className="mui-custom-form with-select w-100">
                    <TextField
                      label="Grouping Column"
                      fullWidth
                      select
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                      inputProps={{ id: 'groupingColumn' }}
                      id="groupingColumn"
                      name="groupingColumn"
                      value={CGPSearchValues?.groupingColumn}
                      disabled={disableGroupingColumn}
                      className={
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'groupingColumn'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('groupingColumn', e.target.value)
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e?.target?.value, 'groupingColumn')
                      }
                      error={
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'groupingColumn' ? l.message : null
                            )
                          : null
                      }
                      helperText={
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'groupingColumn' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {groupingColumnList?.map((item) => {
                        return (
                          <MenuItem key={item.value} value={item.value} className="frr-logcheck-dropdown-item">
                            {item.label}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </div>
                </div>

                <div className="col-sm-8 d-flex align-items-center">
                  <Button
                    className="btn btn-success btn-view mt-3 mr-3"
                    onClick={process}
                    type="button"
                    style={{ textTransform: 'none' }}
                  >
                    <SVGComponent iconName="Create-new-icon" />
                    Process
                  </Button>
                  <Button
                    type="button"
                    className="btn btn-success mt-3"
                    disabled={!disableGroupingColumn}
                    onClick={showChangeGroupingColumnConfirmModal}
                    style={{ textTransform: 'none' }}
                  >
                    Change Grouping Column
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="clearfix" />
      </div>
    </div>
  );
};

export default ClaimGroupingParameter;
